import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueObserveVisibility from 'vue-observe-visibility'
import vSwitch from './components/v-switch.vue'
import App from './App.vue'
import router from './router'
import store from './store'
import httpCache from './utils/httpCache'

Vue.use(BootstrapVue)
Vue.use(VueObserveVisibility)

Vue.component(
  vSwitch.name,
  vSwitch,
)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
  window.store = store
  window.router = router
}

httpCache.setVuexStore(store)

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    // Handle the navigate mutation call. This fixes a circular reference.
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'navigate') {
        const actionType = mutation.payload.type || 'replace'
        router[actionType](mutation.payload)
      }
    })
  },
}).$mount('#app')
